import React from 'react';
import clsx from 'clsx';

import './index.scss';

const RadioInput = ({ value, onChange, onClick, checked, label, id, name }) => {

  return (
    <label htmlFor={id}>
      <span className={clsx('RadioInput', { checked })}>
        <input
          className=''
          type="radio"
          value={value}
          onChange={onChange}
          onClick={onClick}
          checked={checked}
          id={id}
          name={name}
        />
        {label}
      </span>
    </label>
  );

};

export default RadioInput;